import type { IntelligenceReportData } from "../pdf/types"
import { DOMAIN_ORDER, groupByDomain } from "../sharedTokens"
import { CoverPage } from "./pages/CoverPage"
import { OverviewPage } from "./pages/OverviewPage"
import { RecommendedActionsPage } from "./pages/RecommendedActionsPage"
import { SystemConditionPaginator } from "./SystemConditionPaginator"

interface Props {
  report: IntelligenceReportData
  logoUrl?: string | null
}

export function IntelligenceReportHtmlDocument({ report, logoUrl }: Props) {
  const indicatorsByDomain = groupByDomain(report.key_indicators)

  return (
    <>
      <CoverPage report={report} logoUrl={logoUrl} />
      <OverviewPage report={report} />
      <SystemConditionPaginator domains={DOMAIN_ORDER} indicatorsByDomain={indicatorsByDomain} />
      <RecommendedActionsPage report={report} />
    </>
  )
}
